<lib-modal-container class="bootstrap-wrapper" classModalTitle="bg-azul-sunedu" [modalTitle]="'Encuesta'"
  cancelText="Cerrar" [noActions]="true" (dismiss)="handleClose()">

  <div fxLayout="column" class="m-b-25">
    <div *ngIf="sended" class="text-center">
      <label class="font-bold">Gracias por tu respuesta.</label>
    </div>
    <div *ngIf="!sended" class="text-center">
      <label class="font-bold">Coméntanos tu experiencia llenando esta encuesta:</label>
    </div>
    <div *ngIf="showError == false" class="text-center">
      <label class="font-bold">Ocurrió un problema, vuelva a intentarlo.</label>
    </div>
    <form *ngIf="!sended" fxFlex="auto" [formGroup]="form">
      <div class="text-center">
        <label>Los datos proporcionados son de carácter estrictamente reservado y no serán utilizados en otros estudios
          a
          menos que se tenga autorización expresa de los participantes.</label>
      </div>
      <div class="text-left">
        <label class="font-bold">De uso fácil*</label>
      </div>
      <div class="text-left p-20">
        <mat-radio-group formControlName="usoFacil">
          <mat-radio-button value="1">1</mat-radio-button>
          <mat-radio-button value="2">2</mat-radio-button>
          <mat-radio-button value="3">3</mat-radio-button>
          <mat-radio-button value="4">4</mat-radio-button>
          <mat-radio-button value="5">5</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="text-left">
        <label class="font-bold">¿El contenido e información ha sido el esperado por usted?*</label>
      </div>
      <div class="text-left p-20">
        <mat-radio-group formControlName="contenidoInformacion">
          <mat-radio-button value="1">1</mat-radio-button>
          <mat-radio-button value="2">2</mat-radio-button>
          <mat-radio-button value="3">3</mat-radio-button>
          <mat-radio-button value="4">4</mat-radio-button>
          <mat-radio-button value="5">5</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="text-left">
        <div class="font-bold">En general, ¿logró el objetivo al consumir la información?</div>
        <lib-form-control appearance="outline" variant="multiline" [formGroupParent]="form" label="Objetivo"
        controlName="objetivo">
        </lib-form-control>
        <div class="font-bold">¿Qué información esperabas encontrar y no encontraste en el API?</div>
        <lib-form-control appearance="outline" variant="multiline" [formGroupParent]="form" label="Información"
          controlName="informacion">
        </lib-form-control>
      </div>
      <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" formControlName="recaptcha">
      </ngx-recaptcha2>
    </form>
    <div *ngIf="!sended" class="text-center">
      <button (click)="handleEnviar()" [disabled]="loading" mat-flat-button [ngClass]="!loading ? 'bg-azul-sunedu rounded-full m-l-15':'bg-gray-sunedu rounded-full m-l-15'">
        Enviar
      </button>
    </div>
  </div>
</lib-modal-container>